export const routes = {
  home: '/',
  highFake: '/high',
  mediumFake: '/medium',
  lowFake: '/low',
  detailsPage: `/details`,
};
